export const COLOR_SCHEMA = {
  RED: 'red',
  GREEN: '#07d36b',
  PURPIL: '#b996d5',
};

export const INTERVAL_TIME_REFRESH_TOKEN = 90000;

export const HTTP_CODE_RESPONSE = {
  GET_SUCCESS: 200,
  CREATE_SUCCESS: 201,
  UPDATE_SUCCESS: 204,
  DELETE_SUCCESS: 204,
  UNAUTHORIZED: 403,
  NO_SAS_TOKEN: 409,
  UNAUTHENTICATED: 401,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  NOT_ALLOW: 405,
  ERROR: 500,
};

export const DEFAULT_BEGIN_PAGE = 1;
export const DEFAULT_SIZE_PAGE = 10;

export const TEMPORARY = 'TEMPORARY';

/**
 * Live preview portal for office files
 * @constant
 */
export const OFFFICE_LIVE_PREVIEW = 'https://view.officeapps.live.com/op/embed.aspx?src=';

/**
 * Live preview portal for files from Google
 * Should not use, inconsistent behaviour
 * @constant
 * @deprecated
 */
export const GOOGLE_LIVE_PREVIEW = 'https://docs.google.com/viewerng/viewer?url=';

/**
 * Maximum file select when create summary/translation task
 * @constant
 */
export const MAXIMUM_SUMMARY_FILES_SELECT = 5;

/**
 * Maximum concurrent upload request, using to limit concurrent upload file
 * @constant
 */
export const MAX_CONCURRENT_REQUEST = 10;

export const DISPLAY_TEXT_TIME_SPEED = 5;
export const BLINKING_CURSOR_VISIBLE_TIME = 500;

export const SET_TIMEOUT_STREAMING_ANSWER = 1000 * 125;

export const SET_TIMEOUT_STREAMING_ANSWER_Task = 1000 * 185;

export const TEXT_CONSTANT = {
  CONVERSATION: {
    WELCOME_HEADER: 'Welcome to Amatrium GPT',
    WELCOME_BODY:
      'I can answer questions and provide citations from your documents that support the answers, but I have limitations and won’t always get it right.',
    LOADING_ANSWER: "We're finding the answer to your question...",
    NOT_FOUND_ANSWER: 'I can not find answer for your question',
    ERROR_ANSWER: 'Oops!!!,Something went wrong. Please try again.',
  },
  SUMMARY: {
    WELCOME_HEADER: 'Welcome to AmatriumGPT Summary',
    WELCOME_BODY:
      'I can summarize a number of documents to assist in proposals, reports, patents and related products by using your documents. I have limitations and won’t always be correct, yet I will save you an immense amount of time.',
    LOADING_ANSWER: "We're finding the answer to your question...",
    NOT_FOUND_ANSWER: 'I can not find answer for your question',
    ERROR_ANSWER: 'Oops, something went wrong, please try again.',
  },
  TRANSLATION: {
    WELCOME_HEADER: 'Welcome to AmatriumGPT Translator',
    WELCOME_BODY:
      'Easily translate uploaded files with our AI-powered app, offering seamless support for a variety of file formats, ensuring smooth communication across languages for all users.',
  },
};

export enum CONNECTION_STATUS {
  CONNECTED = 'Connected',
  UNAUTHENTICATED = 'Unauthenticated',
}

export const LocaleOptions = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
];
